import { FC } from "react";
import { Score, TeamReference } from "@/models/pdfData";
import { SetStats, Teams } from "@/models/gameState";
import { Box, Typography } from "@mui/material";
import {
  UpdateActionType,
  UpdateActionWithState,
} from "@/models/socketIo/updateAction";
import { isScoringAction, teamScoredInAction } from "@/utils/action-history";

const ActionScore: FC<{
  score: Score;
  teams: Teams;
  variant: "wide" | "narrow";
  team?: TeamReference;
  setNumber?: number;
  playedSets?: SetStats;
  action?: UpdateActionWithState;
}> = ({ score, teams, variant, team, setNumber, playedSets, action }) => {
  if (
    score.team1 === 0 &&
    score.team2 === 0 &&
    setNumber &&
    setNumber > 1 &&
    isScoringAction(action)
  ) {
    const finishedSet = playedSets && playedSets[setNumber - 1];
    if (finishedSet) {
      score = finishedSet.result;
      setNumber -= 1;
    }
  }

  const gridConfig = {
    ["narrow"]: {
      gridTemplateRows: "1fr",
      gridTemplateColumns: "5fr 3fr 5fr 3fr 5fr",
      gridTemplateAreas: `
    "nameTeam1 scoreTeam1 set scoreTeam2 nameTeam2"
    `,
      justifyItems: "center",
      alignSelf: "center",
      columnGap: "0.2em",
      paddingX: "0.5em",
    },
    ["wide"]: {
      gridTemplateRows: "1fr 1fr",
      gridTemplateColumns: "5fr 3fr 3fr",
      gridTemplateAreas: `
    "nameTeam1 scoreTeam1 set"
    "nameTeam2 scoreTeam2 set"
    `,
      columnGap: "1em",
      height: "max-content",
      alignSelf: "center",
    },
  };

  return (
    <Box display={"grid"} sx={{ ...gridConfig[variant] }}>
      <Typography
        fontWeight={teamScoredInAction(action, "team1") ? "bold" : "normal"}
        gridArea={"nameTeam1"}
        alignContent={"center"}
        noWrap
        width={"min-content"}
      >
        {teams.team1.clubCode}
      </Typography>
      <Typography
        fontWeight={teamScoredInAction(action, "team1") ? "bold" : "normal"}
        gridArea={"scoreTeam1"}
        alignContent={"center"}
      >
        {`${score["team1"]}`.padStart(2, "0")}
      </Typography>
      <Typography
        fontWeight={teamScoredInAction(action, "team2") ? "bold" : "normal"}
        gridArea={"nameTeam2"}
        alignContent={"center"}
        noWrap
        width={"min-content"}
      >
        {teams.team2.clubCode}
      </Typography>
      <Typography
        fontWeight={teamScoredInAction(action, "team2") ? "bold" : "normal"}
        gridArea={"scoreTeam2"}
        alignContent={"center"}
      >
        {`${score["team2"]}`.padStart(2, "0")}
      </Typography>
      <Typography
        gridArea={"set"}
        alignContent={"center"}
        justifyContent={"center"}
        alignSelf={"center"}
      >
        {setNumber ? `(${setNumber})` : ""}
      </Typography>
    </Box>
  );
};

export default ActionScore;
